import { DatePipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { CardComponent } from '@components/card/card.component';
import { environment } from '@environments/environment';
import { InHomeBookingResult } from '@Medology/ng-findalab';
import { OrderCompleteDetails } from '@models/order-complete-details';
import { StorageService } from '@services/storage.service';

@Component({
  selector: 'app-order-complete-instructions-healthlabs',
  templateUrl: './order-complete-instructions-healthlabs.component.html',
  imports: [CardComponent, DatePipe],
})
export class OrderCompleteInstructionsHealthlabsComponent implements OnInit {
  @Input() public orderCompleteDetails: OrderCompleteDetails;

  public isFree: boolean;
  public isPayLater: boolean;
  public inHomeBookingResult: InHomeBookingResult;

  protected storageService = inject(StorageService);

  public get cardContentClass(): string {
    return environment.styles.orderCompleteInstructions.cardContentClass;
  }

  public get businessHours(): string {
    return environment.businessHours;
  }

  public get assistanceDetails(): string {
    return `If you have any questions or need assistance in the meantime, our Patient Services and
  Support teams are available ${environment.businessHours}.`;
  }

  public ngOnInit(): void {
    if (this.orderCompleteDetails) {
      this.isFree = this.orderCompleteDetails.free;
      this.isPayLater = this.orderCompleteDetails.isPayLater;
      this.inHomeBookingResult = this.orderCompleteDetails.inHomeBookingResult;
    }
  }
}
